import {BaseContainerModel} from '../base-container.model';
import {bl_applet_one_time_perm_request_history_RowClass} from '../../dbschema';

export class OneTimePermissionRequestContainerModel extends BaseContainerModel {
    bl_applet_one_time_perm_request_history: bl_applet_one_time_perm_request_history_RowClass = new bl_applet_one_time_perm_request_history_RowClass();
}
